(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Provider", [], factory);
	else if(typeof exports === 'object')
		exports["Provider"] = factory();
	else
		root["Provider"] = factory();
})(global, function() {
return 